module.exports = __webpack_public_path__ + "media/icons/ubezpieczenia-192e7d03.png";